import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { GradientIcon } from 'src/components/gradients/GradientIcon';
import { OutcomeElement } from 'src/components/wizard/OutcomeElement';
import {
  WizardElementProps,
  withoutWizardProps,
} from 'src/components/wizard/Wizard';

export const OutcomeSubmit = withoutWizardProps(
  ({
    get,
    go,
  }: WizardElementProps<{ success: boolean; message: string }, string>) => {
    const message = get('message');
    const success = get('success');
    const icon = (
      <GradientIcon
        IconComponent={success ? CheckCircleOutlineIcon : CancelOutlinedIcon}
        gradientColor={success ? 'secondary.horizontal' : 'error.horizontal'}
        sx={{ fontSize: 128 }}
      />
    );

    return <OutcomeElement image={icon} message={message} go={go} />;
  },
);
